import Header from "./Header";
import Footer from "./Footer";
import ChatBot from "./ChatBot";
import "../styles/TermsOfService.css";
import { useEffect, useState } from "react";
import API_BASE_URL from "../config";
import {
    FaGavel,
    FaUserCheck,
    FaFileContract,
    FaShieldAlt,
    FaBalanceScale,
    FaCreditCard,
    FaUserShield,
    FaCopyright,
    FaBan,
    FaExclamationTriangle,
    FaUserLock,
    FaHistory,
    FaGlobe,
    FaEnvelope,
    FaCheckCircle,
    FaChevronRight,
    FaBook,
    FaDownload,
    FaQuestionCircle,
    FaRegCopy,
    FaCalendarAlt,
    FaComments,
    FaLightbulb,
    FaHandshake
} from "react-icons/fa";

export default function TermsOfService() {
    const [contactEmail, setContactEmail] = useState("");
    const [activeTab, setActiveTab] = useState("acceptance");
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const fetchSiteSettings = async () => {
            try {
                const res = await fetch(`${API_BASE_URL}/api/site-settings`);
                const data = await res.json();

                if (data?.contactEmail) {
                    setContactEmail(data.contactEmail);
                }
            } catch (err) {
                console.error("Error fetching site settings:", err);
            }
        };

        fetchSiteSettings();
    }, []);

    const tabs = [
        {
            id: "acceptance",
            title: "Acceptance",
            subtitle: "Terms agreement & platform usage",
            icon: <FaHandshake />,
            color: "#d6b87c"
        },
        {
            id: "platform",
            title: "Platform Scope",
            subtitle: "Service nature & limitations",
            icon: <FaGavel />,
            color: "#c2a57a"
        },
        {
            id: "eligibility",
            title: "Eligibility",
            subtitle: "User requirements & responsibilities",
            icon: <FaUserCheck />,
            color: "#b8945c"
        },
        {
            id: "disclaimer",
            title: "Legal Disclaimer",
            subtitle: "Service limitations & solicitor role",
            icon: <FaExclamationTriangle />,
            color: "#a57a42"
        },
        {
            id: "services",
            title: "Services",
            subtitle: "Appointments & communications",
            icon: <FaCalendarAlt />,
            color: "#d6b87c"
        },
        {
            id: "updates",
            title: "Updates & Contact",
            subtitle: "Changes & communications",
            icon: <FaHistory />,
            color: "#a57a42"
        }
    ];

    const renderContent = () => {
        switch (activeTab) {
            case "acceptance":
                return (
                    <div className="jus-tos-tab-content">
                        <div className="jus-tos-content-header">
                            <div className="jus-tos-content-icon" style={{ background: "linear-gradient(135deg, #d6b87c 0%, #c2a57a 100%)" }}>
                                <FaHandshake />
                            </div>
                            <div>
                                <h2>Acceptance of Terms</h2>
                                <p className="jus-tos-content-subtitle">
                                    By accessing or using Justivon, you agree to be bound by these Terms of Service and our Privacy Policy.
                                </p>
                            </div>
                        </div>

                        <div className="jus-tos-agreement-grid">
                            <div className="jus-tos-agreement-card">
                                <div className="jus-tos-agreement-icon" style={{ backgroundColor: "rgba(214, 184, 124, 0.1)" }}>
                                    <FaCheckCircle />
                                </div>
                                <div className="jus-tos-agreement-content">
                                    <h3>Express Agreement</h3>
                                    <p>Your use of the platform constitutes explicit acceptance of these terms, creating a binding legal agreement between you and Justivon.</p>
                                    <ul>
                                        <li><strong>Account creation</strong> implies full acceptance</li>
                                        <li><strong>Continued use</strong> after updates signifies agreement</li>
                                        <li><strong>Electronic consent</strong> is legally binding</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="jus-tos-agreement-card">
                                <div className="jus-tos-agreement-icon" style={{ backgroundColor: "rgba(194, 165, 122, 0.1)" }}>
                                    <FaBook />
                                </div>
                                <div className="jus-tos-agreement-content">
                                    <h3>Incorporated Documents</h3>
                                    <p>These Terms incorporate by reference additional policies and guidelines that govern specific aspects of platform use.</p>
                                    <ul>
                                        <li><strong>Privacy Policy</strong> - Data protection practices</li>
                                        <li><strong>Cookie Policy</strong> - Digital tracking preferences</li>
                                        <li><strong>Acceptable Use Policy</strong> - Platform conduct rules</li>
                                        <li><strong>Solicitor Terms</strong> - Professional service terms</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="jus-tos-agreement-card">
                                <div className="jus-tos-agreement-icon" style={{ backgroundColor: "rgba(184, 148, 92, 0.1)" }}>
                                    <FaBalanceScale />
                                </div>
                                <div className="jus-tos-agreement-content">
                                    <h3>Withdrawal Right</h3>
                                    <p>If you do not agree to these terms, you must immediately cease using the platform and refrain from accessing our services.</p>
                                    <div className="jus-tos-notice-box">
                                        <FaExclamationTriangle />
                                        <p>Continuing to use Justivon after reviewing these terms constitutes your legal acceptance of all conditions herein.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="jus-tos-agreement-card">
                                <div
                                    className="jus-tos-agreement-icon"
                                    style={{ backgroundColor: "rgba(122, 162, 214, 0.1)" }}
                                >
                                    <FaHistory />
                                </div>
                                <div className="jus-tos-agreement-content">
                                    <h3>Terms Modification Acceptance</h3>
                                    <p>
                                        Justivon may update these Terms of Service periodically. Continued use of
                                        the platform after updates signifies your acceptance of the revised terms.
                                    </p>
                                    <ul>
                                        <li><strong>Advance notice</strong> for material changes</li>
                                        <li><strong>Updated versions</strong> published on this page</li>
                                        <li><strong>Ongoing usage</strong> confirms agreement</li>
                                    </ul>
                                </div>
                            </div>


                        </div>
                    </div>
                );

            case "platform":
                return (
                    <div className="jus-tos-tab-content">
                        <div className="jus-tos-content-header">
                            <div className="jus-tos-content-icon" style={{ background: "linear-gradient(135deg, #c2a57a 0%, #b8945c 100%)" }}>
                                <FaGavel />
                            </div>
                            <div>
                                <h2>Platform Nature & Scope</h2>
                                <p className="jus-tos-content-subtitle">
                                    Understanding what Justivon provides and its role in connecting users with legal professionals.
                                </p>
                            </div>
                        </div>

                        <div className="jus-tos-platform-cards">
                            <div className="jus-tos-platform-card" style={{ borderTop: "4px solid #d6b87c" }}>
                                <div className="jus-tos-platform-number">
                                    <span>01</span>
                                </div>
                                <h3>Legal Matching Service</h3>
                                <p>Justivon operates as a technology platform that facilitates connections between users seeking legal services and verified solicitors.</p>
                                <div className="jus-tos-platform-features">
                                    <span>Verified solicitor database</span>
                                    <span>Service area matching</span>
                                    <span>Appointment coordination</span>
                                </div>
                            </div>

                            <div className="jus-tos-platform-card" style={{ borderTop: "4px solid #c2a57a" }}>
                                <div className="jus-tos-platform-number">
                                    <span>02</span>
                                </div>
                                <h3>Not a Law Firm</h3>
                                <p>Justivon does not provide legal advice, represent clients, or establish attorney-client relationships through the platform.</p>
                                <div className="jus-tos-platform-features">
                                    <span>No legal representation</span>
                                    <span>No attorney-client privilege</span>
                                    <span>Independent solicitors only</span>
                                </div>
                            </div>

                            <div className="jus-tos-platform-card" style={{ borderTop: "4px solid #b8945c" }}>
                                <div className="jus-tos-platform-number">
                                    <span>03</span>
                                </div>
                                <h3>Service Limitations</h3>
                                <p>The platform facilitates introductions but does not guarantee case outcomes, solicitor availability, or service quality.</p>
                                <div className="jus-tos-platform-features">
                                    <span>No outcome guarantees</span>
                                    <span>Solicitor availability varies</span>
                                    <span>Geographic restrictions apply</span>
                                </div>
                            </div>

                            <div className="jus-tos-platform-card" style={{ borderTop: "4px solid #a57a42" }}>
                                <div className="jus-tos-platform-number">
                                    <span>04</span>
                                </div>
                                <h3>Regulatory Compliance</h3>
                                <p>All solicitors on our platform are independently regulated by appropriate legal authorities in their jurisdictions.</p>
                                <div className="jus-tos-platform-features">
                                    <span>SRA regulation (UK)</span>
                                    <span>Professional indemnity insurance</span>
                                    <span>Practice certificate verification</span>
                                </div>
                            </div>
                        </div>
                    </div>
                );

            case "eligibility":
                return (
                    <div className="jus-tos-tab-content">
                        <div className="jus-tos-content-header">
                            <div className="jus-tos-content-icon" style={{ background: "linear-gradient(135deg, #b8945c 0%, #a57a42 100%)" }}>
                                <FaUserCheck />
                            </div>
                            <div>
                                <h2>User Eligibility & Requirements</h2>
                                <p className="jus-tos-content-subtitle">
                                    Minimum requirements and conditions for accessing and using the Justivon platform.
                                </p>
                            </div>
                        </div>

                        <div className="jus-tos-eligibility-grid">
                            <div className="jus-tos-eligibility-card">
                                <div className="jus-tos-eligibility-icon">
                                    <FaUserCheck />
                                </div>
                                <h3>Age Requirement</h3>
                                <p>You must be at least 18 years old to create an account and use Justivon's services independently.</p>
                                <div className="jus-tos-eligibility-detail">
                                    <FaCheckCircle />
                                    <span>18+ years minimum age</span>
                                </div>
                            </div>

                            <div className="jus-tos-eligibility-card">
                                <div className="jus-tos-eligibility-icon">
                                    <FaRegCopy />
                                </div>
                                <h3>Accuracy Obligation</h3>
                                <p>All information provided during registration and service requests must be accurate, complete, and current.</p>
                                <div className="jus-tos-eligibility-detail">
                                    <FaExclamationTriangle />
                                    <span>False information may lead to termination</span>
                                </div>
                            </div>

                            <div className="jus-tos-eligibility-card">
                                <div className="jus-tos-eligibility-icon">
                                    <FaShieldAlt />
                                </div>
                                <h3>Account Security</h3>
                                <p>You are solely responsible for maintaining the confidentiality of your account credentials and all activities under your account.</p>
                                <div className="jus-tos-eligibility-detail">
                                    <FaUserLock />
                                    <span>Immediate notification required for unauthorized access</span>
                                </div>
                            </div>

                            <div className="jus-tos-eligibility-card">
                                <div className="jus-tos-eligibility-icon">
                                    <FaGlobe />
                                </div>
                                <h3>Geographic Eligibility</h3>
                                <p>Services are available only in jurisdictions where Justivon operates and where such services are legally permitted.</p>
                                <div className="jus-tos-eligibility-detail">
                                    <FaGlobe />
                                    <span>UK-focused with planned expansion</span>
                                </div>
                            </div>
                        </div>

                        <div className="jus-tos-compliance-section">
                            <div className="jus-tos-compliance-header">
                                <FaExclamationTriangle className="jus-tos-compliance-icon" />
                                <h3>Prohibited Users</h3>
                            </div>
                            <p>
                                Individuals previously suspended or terminated from Justivon, or those whose use could damage, disable, overburden,
                                or impair the platform are prohibited from accessing our services.
                            </p>
                        </div>
                    </div>
                );

            case "disclaimer":
                return (
                    <div className="jus-tos-tab-content">
                        <div className="jus-tos-content-header">
                            <div className="jus-tos-content-icon" style={{ background: "linear-gradient(135deg, #a57a42 0%, #8c6b35 100%)" }}>
                                <FaExclamationTriangle />
                            </div>
                            <div>
                                <h2>Legal Services Disclaimer</h2>
                                <p className="jus-tos-content-subtitle">
                                    Important limitations regarding legal advice and solicitor relationships through the platform.
                                </p>
                            </div>
                        </div>

                        <div className="jus-tos-disclaimer-flow">
                            <div className="jus-tos-disclaimer-step">
                                <div className="jus-tos-step-number">1</div>
                                <h3>Independent Solicitor Relationships</h3>
                                <p>Any legal advice or services are provided solely by independent solicitors. Justivon does not participate in, nor is responsible for, attorney-client relationships.</p>
                                <ul>
                                    <li><strong>Solicitors are independent contractors</strong>, not Justivon employees</li>
                                    <li><strong>Attorney-client privilege</strong> exists only between you and your solicitor</li>
                                    <li><strong>Justivon does not review</strong> or supervise legal advice provided</li>
                                </ul>
                            </div>

                            <div className="jus-tos-disclaimer-step">
                                <div className="jus-tos-step-number">2</div>
                                <h3>No Quality Guarantee</h3>
                                <p>While we verify solicitor credentials, we do not guarantee the quality, accuracy, timeliness, or outcomes of legal services provided.</p>
                                <ul>
                                    <li><strong>No endorsement</strong> of specific legal strategies</li>
                                    <li><strong>No outcome predictions</strong> or success guarantees</li>
                                    <li><strong>Solicitor performance</strong> is independently managed</li>
                                </ul>
                            </div>

                            <div className="jus-tos-disclaimer-step">
                                <div className="jus-tos-step-number">3</div>
                                <h3>Conflict Checks & Due Diligence</h3>
                                <p>Solicitors are responsible for conducting their own conflict checks and due diligence. Justivon does not perform legal conflict analysis.</p>
                                <ul>
                                    <li><strong>Users must disclose</strong> all relevant case information</li>
                                    <li><strong>Solicitors conduct</strong> independent conflict checks</li>
                                    <li><strong>Platform does not</strong> verify case-specific compatibility</li>
                                </ul>
                            </div>
                        </div>

                        <div className="jus-tos-warning-box">
                            <FaExclamationTriangle className="jus-tos-warning-icon" />
                            <div>
                                <h4>Important Legal Notice</h4>
                                <p>
                                    Legal services have inherent risks. Justivon recommends you conduct independent research and consult multiple
                                    solicitors before making legal decisions. Platform matching is informational, not a substitute for professional judgment.
                                </p>
                            </div>
                        </div>
                    </div>
                );

            case "services":
                return (
                    <div className="jus-tos-tab-content">
                        <div className="jus-tos-content-header">
                            <div className="jus-tos-content-icon" style={{ background: "linear-gradient(135deg, #d6b87c 0%, #c2a57a 100%)" }}>
                                <FaCalendarAlt />
                            </div>
                            <div>
                                <h2>Appointments & Communications</h2>
                                <p className="jus-tos-content-subtitle">
                                    Guidelines for scheduling appointments and using communication features on the platform.
                                </p>
                            </div>
                        </div>

                        <div className="jus-tos-services-grid">
                            <div className="jus-tos-service-card">
                                <div className="jus-tos-service-icon" style={{ backgroundColor: "rgba(214, 184, 124, 0.1)" }}>
                                    <FaCalendarAlt />
                                </div>
                                <div className="jus-tos-service-content">
                                    <h3>Scheduling System</h3>
                                    <p>Appointments are scheduled directly between users and solicitors through our integrated calendar system.</p>
                                    <ul>
                                        <li>Real-time availability viewing</li>
                                        <li>Automatic time zone conversion</li>
                                        <li>Reminder notifications (email/SMS)</li>
                                        <li>Cancellation and rescheduling policies apply</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="jus-tos-service-card">
                                <div className="jus-tos-service-icon" style={{ backgroundColor: "rgba(194, 165, 122, 0.1)" }}>
                                    <FaComments />
                                </div>
                                <div className="jus-tos-service-content">
                                    <h3>Secure Messaging</h3>
                                    <p>End-to-end encrypted messaging for confidential communications between users and solicitors.</p>
                                    <ul>
                                        <li>Encrypted message storage</li>
                                        <li>File attachment capabilities</li>
                                        <li>Read receipts and delivery confirmations</li>
                                        <li>Message retention according to data policy</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="jus-tos-service-card">
                                <div className="jus-tos-service-icon" style={{ backgroundColor: "rgba(184, 148, 92, 0.1)" }}>
                                    <FaLightbulb />
                                </div>
                                <div className="jus-tos-service-content">
                                    <h3>Communication Guidelines</h3>
                                    <p>Rules and expectations for professional communication through the platform.</p>
                                    <ul>
                                        <li>Professional language required</li>
                                        <li>No harassment or abusive content</li>
                                        <li>Reasonable response time expectations</li>
                                        <li>Emergency services disclaimer</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="jus-tos-service-card">
                                <div className="jus-tos-service-icon" style={{ backgroundColor: "rgba(122, 162, 214, 0.1)" }}>
                                    <FaShieldAlt />
                                </div>
                                <div className="jus-tos-service-content">
                                    <h3>Platform Monitoring</h3>
                                    <p>While we facilitate communication, certain automated systems may monitor for security and compliance purposes.</p>
                                    <ul>
                                        <li>Automated spam detection</li>
                                        <li>Security threat monitoring</li>
                                        <li>Compliance keyword scanning</li>
                                        <li>No human review of private legal discussions</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                );

            // Additional cases for responsibilities, intellectual, termination, liability, privacy, updates
            // Pattern continues similar to above...

            case "updates":
                return (
                    <div className="jus-tos-tab-content">
                        <div className="jus-tos-content-header">
                            <div className="jus-tos-content-icon" style={{ background: "linear-gradient(135deg, #c2a57a 0%, #b8945c 100%)" }}>
                                <FaHistory />
                            </div>
                            <div>
                                <h2>Updates & Contact Information</h2>
                                <p className="jus-tos-content-subtitle">
                                    How we communicate changes to these terms and how you can contact us with questions.
                                </p>
                            </div>
                        </div>

                        <div className="jus-tos-update-timeline">
                            <div className="jus-tos-timeline-item">
                                <div className="jus-tos-timeline-dot"></div>
                                <div className="jus-tos-timeline-content">
                                    <h3>Term Modifications</h3>
                                    <p>We reserve the right to modify these terms at any time. Material changes will be communicated at least 30 days before taking effect.</p>
                                </div>
                            </div>

                            <div className="jus-tos-timeline-item">
                                <div className="jus-tos-timeline-dot"></div>
                                <div className="jus-tos-timeline-content">
                                    <h3>Continued Use Acceptance</h3>
                                    <p>Your continued use of the platform after changes are posted constitutes acceptance of the revised terms.</p>
                                </div>
                            </div>

                            <div className="jus-tos-timeline-item">
                                <div className="jus-tos-timeline-dot"></div>
                                <div className="jus-tos-timeline-content">
                                    <h3>Version Archive</h3>
                                    <p>Previous versions of these terms are archived and available upon request for transparency and reference purposes.</p>
                                </div>
                            </div>
                        </div>

                        <div className="jus-tos-contact-section">
                            <div className="jus-tos-contact-card">
                                <div className="jus-tos-contact-header">
                                    <FaEnvelope className="jus-tos-contact-main-icon" />
                                    <h3>Contact & Support</h3>
                                </div>
                                <div className="jus-tos-contact-details">
                                    <div className="jus-tos-contact-item">
                                        <strong>Legal Inquiries</strong>
                                        <p>{contactEmail || "legal@justivon.com"}</p>
                                    </div>
                                    <div className="jus-tos-contact-item">
                                        <strong>Response Time</strong>
                                        <p>Within 5 business days for term-related inquiries</p>
                                    </div>
                                    <div className="jus-tos-contact-item">
                                        <strong>Dispute Resolution</strong>
                                        <p>Formal disputes must follow our dispute resolution process</p>
                                    </div>
                                </div>
                            </div>

                            <div className="jus-tos-governance-card">
                                <div className="jus-tos-governance-header">
                                    <FaGavel className="jus-tos-governance-icon" />
                                    <h3>Governing Law</h3>
                                </div>
                                <p>
                                    These terms are governed by the laws of the appropriate jurisdiction. Any disputes shall be resolved
                                    through arbitration or in the courts of the relevant jurisdiction.
                                </p>
                                <a
                                    href="#jurisdiction"
                                    className="jus-tos-jurisdiction-link"
                                >
                                    View Jurisdiction Details <FaChevronRight />
                                </a>
                            </div>
                        </div>
                    </div>
                );

            default:
                return (
                    <div className="jus-tos-tab-content">
                        <div className="jus-tos-content-header">
                            <div className="jus-tos-content-icon" style={{ background: "linear-gradient(135deg, #d6b87c 0%, #c2a57a 100%)" }}>
                                <FaFileContract />
                            </div>
                            <div>
                                <h2>Terms of Service</h2>
                                <p className="jus-tos-content-subtitle">
                                    Comprehensive legal agreement governing your use of the Justivon platform and services.
                                </p>
                            </div>
                        </div>
                        <p>Select a section from the sidebar to view detailed terms.</p>
                    </div>
                );
        }
    };

    return (
        <div className="jus-tos-container">
            <Header />

            {/* Hero Section */}
            <section className="jus-tos-hero">
                <div className="jus-tos-hero-content">
                    <div className="jus-tos-hero-badge">
                        <FaGavel />
                        <span>Legal Agreement</span>
                    </div>
                    <h1 className="jus-tos-hero-title">
                        Terms of <span className="jus-tos-highlight">Service</span>
                    </h1>
                    <p className="jus-tos-hero-subtitle">
                        The legal agreement governing your use of Justivon's legal matching platform and services.
                    </p>
                    <div className="jus-tos-hero-meta">
                        <div className="jus-tos-meta-item">
                            <FaHistory />
                            <span>Last Updated: March 2024</span>
                        </div>
                        <div className="jus-tos-meta-item">
                            <FaFileContract />
                            <span>Version 3.2</span>
                        </div>
                        <div className="jus-tos-meta-item">
                            <FaBalanceScale />
                            <span>Legally Binding</span>
                        </div>
                    </div>
                </div>
                <div className="jus-tos-hero-pattern"></div>
            </section>

            {/* Main Content */}
            <main className="jus-tos-main">
                <div className="jus-tos-content-wrapper">
                    {/* Navigation Sidebar */}
                    <nav className="jus-tos-sidebar">
                        <div className="jus-tos-sidebar-header">
                            <h3>Terms Sections</h3>
                            <p>Navigate through our comprehensive legal terms</p>
                        </div>
                        <div className="jus-tos-sidebar-tabs">
                            {tabs.map(tab => (
                                <button
                                    key={tab.id}
                                    className={`jus-tos-sidebar-tab ${activeTab === tab.id ? 'active' : ''}`}
                                    onClick={() => setActiveTab(tab.id)}
                                >
                                    <div
                                        className="jus-tos-tab-indicator"
                                        style={{ backgroundColor: tab.color }}
                                    ></div>
                                    <div className="jus-tos-tab-content-wrapper">
                                        <div className="jus-tos-tab-icon" style={{ color: tab.color }}>
                                            {tab.icon}
                                        </div>
                                        <div className="jus-tos-tab-text">
                                            <span className="jus-tos-tab-title">{tab.title}</span>
                                            <span className="jus-tos-tab-subtitle">{tab.subtitle}</span>
                                        </div>
                                        {activeTab === tab.id && (
                                            <FaChevronRight className="jus-tos-tab-arrow" />
                                        )}
                                    </div>
                                </button>
                            ))}
                        </div>
                    </nav>

                    {/* Content Area */}
                    <div className="jus-tos-content-container">
                        <div className="jus-tos-content-area">
                            {renderContent()}
                        </div>
                    </div>
                </div>

                {/* Resources Section */}
                <div className="jus-tos-resources">
                    <div className="jus-tos-resources-header">
                        <h3>Legal Resources</h3>
                        <p>Additional documents and tools for understanding our terms</p>
                    </div>
                    <div className="jus-tos-resources-grid">
                        <a href="/faq" className="jus-tos-resource-card">
                            <div className="jus-tos-resource-icon">
                                <FaQuestionCircle />
                            </div>
                            <div className="jus-tos-resource-content">
                                <h4>Terms FAQ</h4>
                                <p>Common questions about our terms</p>
                            </div>
                            <FaChevronRight className="jus-tos-resource-arrow" />
                        </a>

                        <a href="#download" className="jus-tos-resource-card">
                            <div className="jus-tos-resource-icon">
                                <FaDownload />
                            </div>
                            <div className="jus-tos-resource-content">
                                <h4>Download Terms</h4>
                                <p>PDF version for your records</p>
                            </div>
                            <FaChevronRight className="jus-tos-resource-arrow" />
                        </a>

                        <button
                            className="jus-tos-resource-card"
                            onClick={() =>
                                window.scrollTo({
                                    top: 430,
                                    behavior: "smooth"
                                })
                            }
                        >
                            <div className="jus-tos-resource-icon">
                                <FaRegCopy />
                            </div>
                            <div className="jus-tos-resource-content">
                                <h4>Accept Terms</h4>
                                <p>Review and accept terms</p>
                            </div>
                            <FaChevronRight className="jus-tos-resource-arrow" />
                        </button>

                        <a
                            href={`mailto:${contactEmail || "legal@justivon.com"}`}
                            className="jus-tos-resource-card"
                        >
                            <div className="jus-tos-resource-icon">
                                <FaEnvelope />
                            </div>
                            <div className="jus-tos-resource-content">
                                <h4>Contact Legal</h4>
                                <p>Questions about terms</p>
                            </div>
                            <FaChevronRight className="jus-tos-resource-arrow" />
                        </a>
                    </div>
                </div>
            </main>
            <ChatBot />
            <Footer />
        </div>
    );
}